
import { useNavigate } from "react-router-dom";
import { TableBody, TableCell, TableHead, TableRow, Stack,  Typography, IconButton, Pagination } from "@mui/material";
import { MensajeAlertaDanger } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useUsuariosStore } from "../../../stores/usuarios/usuarios.store";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";
const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaListadoUsuarios = ({ data, chagePage=() => {}, page=0, mostrar=false }) => {

    
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { total, startCambiarEstadoUsuario } = useUsuariosStore();



    const handleInfoUsuario = (id) => {
        return navigate(`/super/opciones-user/${ id }`) 
    }



    const handleTrueFalse = async (e, user) => {
        e.stopPropagation();
        const accion = user.activo ? "bloquear" : "activar";
        const { isConfirmed } = await Swal.fire({
            title: "Confirmar cambio de estado",
            text: `¿Desea ${accion} este usuario?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, seguro",
            cancelButtonText: "Cancelar",
        });

        if (!isConfirmed) return;

        const resp = await startCambiarEstadoUsuario(user.id);
        if (resp) queryClient.invalidateQueries({ queryKey: ["user-xrole"] });
    };



    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(total / +paginado)} disabled={Math.ceil(total / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'5%'}}>A.</TableCell>
                        <TableCell sx={{width:'23%'}}>Nombre</TableCell>
                        <TableCell sx={{width:'20%'}}>Ciudad</TableCell>
                        <TableCell sx={{width:'12%'}}>Movil</TableCell>
                        <TableCell sx={{width:'15%'}}>Profesion</TableCell>
                        <TableCell sx={{width:'15%'}}>Rol</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((user) => (
                    <TableRow key={ user.id } onClick={() => handleInfoUsuario(user.id) } sx={{cursor:'pointer'}}>
                        <TableCell >
                        {( user.activo )
                            ? <IconButton 
                                className='boton-estado trru'
                                onClick={ (e) => handleTrueFalse(e,user) }
                            />
                            : <IconButton 
                                className='boton-estado fall'
                                onClick={ (e) => handleTrueFalse(e,user) }
                            />
                        }
                        </TableCell>
                        <TableCell >
                            <Typography variant="span" >{ user.nombre }</Typography>
                        </TableCell>
                        <TableCell>
                            {( user.ciudad )
                            ?   <Typography variant="span" >{ user.ciudad }</Typography>
                            :   <Typography variant="span" color='error'>No Hay Datos</Typography>
                            }
                        </TableCell>
                        <TableCell>
                            {( user.movil )
                            ?   <Typography variant="span" >{ user.movil }</Typography>
                            :   <Typography variant="span" color='error'>No Hay Datos</Typography>
                            }
                        </TableCell>
                        <TableCell>
                            {( user.profesion )
                            ?   <Typography variant="span" >{ user.profesion }</Typography>
                            :   <Typography variant="span" color='error'>No Hay Datos</Typography>
                            }
                        </TableCell>
                        <TableCell >
                            <Typography variant="span" >{ user.role }</Typography>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        :   (!mostrar)
        ?    <MensajeAlertaDanger titulo='No hay Usuarios Disponibles' />
        :   ''
        }
        </>
    )
}
